export { default } from './ResourceAccess';
